module.exports = __webpack_public_path__ + "static/2-membership-benefit-369f1a10a13ae0d71b8a0a926fd2e1d5.png";